import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Stepper from "../../components/Stepper";
import { patchTimezone } from "../../api/profile";

const TIMEZONES = [
  { label: "Москва (UTC+3)", value: "Europe/Moscow" },
  { label: "Калининград (UTC+2)", value: "Europe/Kaliningrad" },
  { label: "Екатеринбург (UTC+5)", value: "Asia/Yekaterinburg" },
  { label: "Новосибирск (UTC+7)", value: "Asia/Novosibirsk" },
  { label: "Красноярск (UTC+7)", value: "Asia/Krasnoyarsk" },
  { label: "Иркутск (UTC+8)", value: "Asia/Irkutsk" },
  { label: "Владивосток (UTC+10)", value: "Asia/Vladivostok" },
];

export default function SetTimezoneScreen() {
  const [timezone, setTimezone] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const ok = await patchTimezone(timezone);
      if (!ok) throw new Error("Ошибка сервера!");

      navigate("/onboarding/install-pwa");
    } catch (e: any) {
      setError(e.message || "Ошибка сервера");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen w-full flex flex-col bg-white">
      {/* Stepper */}
      <header className="w-full p-4">
        <Stepper
          current={2}
          steps={[
            { title: "Email" },
            { title: "Часовой пояс" },
            { title: "Установка" },
          ]}
        />
      </header>

      {/* Content */}
      <section className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="rounded-2xl border border-gray-200 shadow-[0_6px_24px_rgba(0,0,0,0.06)] p-6 md:p-8">
            <h2 className="text-2xl font-bold mb-4 text-center">
              Выберите ваш часовой пояс
            </h2>

            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <select
                className="border rounded-lg px-4 py-2 text-base"
                value={timezone}
                onChange={(e) => setTimezone(e.target.value)}
                required
              >
                <option value="">Выберите таймзону...</option>
                {TIMEZONES.map((tz) => (
                  <option key={tz.value} value={tz.value}>
                    {tz.label}
                  </option>
                ))}
              </select>

              {error && <div className="text-red-600 text-sm">{error}</div>}

              <button
                type="submit"
                className="bg-black text-white rounded-lg py-2 font-bold"
                disabled={loading || !timezone}
              >
                {loading ? "Сохранение..." : "Сохранить и продолжить"}
              </button>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}
